import type { FC } from 'react';
import { links } from './menu.const';
import { StyledNav, StyledParagraph } from './menu.styles';
import { NavLink } from 'react-router';

export const DesktopMenu: FC = () => {
  return (
    <StyledNav>
      {links.map((link) => {
        const { title, to } = link;

        return (
          <StyledParagraph key={`nav-link-${to}`}>
            <NavLink title={title} to={to}>
              {title}
            </NavLink>
          </StyledParagraph>
        );
      })}
    </StyledNav>
  );
};
